// helpful type conversion functions for the video players
import type {PlaybackRate} from "./types.ts";

export const getPlaybackRateNumber: (
    playbackRate?: PlaybackRate | null | undefined,
) => number = (playbackRate) => {
    switch (playbackRate) {
        case "RATE_25_PERCENT":
            return 0.25;
        case "RATE_50_PERCENT":
            return 0.5;
        case "RATE_75_PERCENT":
            return 0.75;
        case "RATE_100_PERCENT":
            return 1;
        case "RATE_125_PERCENT":
            return 1.25;
        case "RATE_150_PERCENT":
            return 1.5;
        case "RATE_175_PERCENT":
            return 1.75;
        case "RATE_200_PERCENT":
            return 2;
        default:
            return 1;
    }
};

export const getPlaybackRateEnum: (
    rate?: number | null | undefined,
) => PlaybackRate | null | undefined = (rate) => {
    switch (rate) {
        case 0.25:
            return "RATE_25_PERCENT";
        case 0.5:
            return "RATE_50_PERCENT";
        case 0.75:
            return "RATE_75_PERCENT";
        case 1:
            return "RATE_100_PERCENT";
        case 1.25:
            return "RATE_125_PERCENT";
        case 1.5:
            return "RATE_150_PERCENT";
        case 1.75:
            return "RATE_175_PERCENT";
        case 2:
            return "RATE_200_PERCENT";
        default:
            // if we get a setting we don't expect, do nothing
            return null;
    }
};
